


















































import Vue, { PropOptions } from 'vue';
import HMCustomContent from '@/web/components/common/HMCustomContent.vue';
import {
  getMediaInfoType,
  typeInfo,
  formatVideoLengthFromSeconds,
} from '@/web/utils/media';
import MediaThumbnail from '@/web/components/products/MediaThumbnail.vue';
interface Props {
  content: PropOptions;
}

export default Vue.extend({
  name: 'ContentCard',
  components: {
    HMCustomContent,
    MediaThumbnail,
  },
  props: {
    content: {
      type: Object as () => ContentResponse,
      required: true,
    },
  } as Props,
  computed: {
    info() {
      if (!this.content.media) return;
      return typeInfo[getMediaInfoType(this.content.media)];
    },
    videoLength() {
      if (!this.content?.media?.video_length) return;
      return formatVideoLengthFromSeconds(this.content.media.video_length);
    },
  },
});
